// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-card .btn[data-v-2e681f7a]{margin-right:.5rem;margin-top:.5rem}.card-subtitle[data-v-2e681f7a]{margin-top:.5rem;margin-bottom:.375rem;font-size:.75rem;color:#4d4d4d;text-transform:uppercase}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
